import { useState } from "react";
import { flushSync } from "react-dom";
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  size,
} from "@floating-ui/react";

type UseFloatingMenuParams = {
  offsetValue: number;
};

export function useFloatingMenu(params: UseFloatingMenuParams) {
  const { offsetValue } = params;

  const [availableListHeight, setAvailableListHeight] = useState<number>();

  const { refs, floatingStyles } = useFloating({
    placement: "bottom",
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(offsetValue),
      flip({ padding: 16 }),
      size({
        padding: 16,
        apply({ rects, elements, availableHeight }) {
          Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`,
          });
          flushSync(() => setAvailableListHeight(availableHeight));
        },
      }),
    ],
  });

  return { refs, floatingStyles, availableListHeight };
}
